import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 6rem auto;
  padding: 0 2rem;
  overflow: hidden;
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #17253D;
  margin-bottom: 2rem;
  text-align: center;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #3454D1, #0891b2);
    border-radius: 2px;
  }
`;

export const Content = styled.div`
  margin-top: 2rem;
  
  > p {
    text-align: center;
    font-size: 1.1rem;
    color: #4B5563;
    max-width: 800px;
    margin: 0 auto 3rem;
    line-height: 1.7;
  }
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

export const Feature = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }
`;

export const FeatureIcon = styled.div`
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #3454D1, #0891b2);
  border-radius: 50%;
  margin-bottom: 1.5rem;
  color: white;
  font-size: 1.8rem;
  box-shadow: 0 10px 15px -3px rgba(52, 84, 209, 0.2);
`;

export const FeatureText = styled.div`
  text-align: center;
  
  h3 {
    font-size: 1.3rem;
    font-weight: 600;
    color: #17253D;
    margin-bottom: 1rem;
  }
  
  p {
    color: #4B5563;
    line-height: 1.6;
    font-size: 0.95rem;
  }
`;
